<template>
  <section class="taskManagementPage">
    <GBreadcrumb bread="园所管理, 园所教材管理" />
    <SearchForm>
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px" @submit.native.prevent>
        <el-form-item>
          <el-cascader
            v-model="searchForm.kindergartenId"
            style="width: 250px;"
            :options="orgGardenTree"
            placeholder="请选择园所"
            clearable
            filterable
            collapse-tags
            :props="{ multiple: false, checkStrictly: false, emitPath: false, label: 'orgName', value: 'orgId' }"
            @change="selectChange"
          />
        </el-form-item>
        <el-form-item>
          <GSelect v-model="searchForm.subjectId" :options="selectOptionsSubject" :placeholder="'请选择科目'" />
        </el-form-item>
        <el-form-item>
          <GSelect v-model="searchForm.teachingGrade" :options="selectOptionsLevel" :placeholder="'请选择教材等级'" />
        </el-form-item>
        <el-form-item>
          <GSelect v-model="searchForm.teachingType" :options="selectOptionsType" :placeholder="'请选择课程类型'" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.teachingName" :placeholder="'请输入教材名称'" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBySync">搜 索</el-button>
        </el-form-item>
      </el-form>
    </SearchForm>
    <TableContainer title="园所教材管理">
      <template slot="button">
        <el-button type="warning" @click="addTextBook">园所添加教材</el-button>
      </template>
      <el-table ref="multipleTable" :key="tableKey" :data="textBookList" style="width: 100%">
        <el-table-column prop="kindergartenName" label="园所名称" min-width="100" />
        <el-table-column prop="subjectName" label="科目名称" min-width="100" />
        <el-table-column prop="teachingName" label="教材名称" min-width="100" />
        <el-table-column prop="teachingGrade" label="教材等级" min-width="100" />
        <el-table-column prop="bookPrice" label="实体书价格" min-width="100">
          <template slot-scope="scope">
            <section v-if="scope.row.isBook	=== '1'">{{ scope.row.bookPrice }}</section>
            <section v-else>/</section>
          </template>
        </el-table-column>
        <el-table-column prop="appCurriculumPrice" label="app课程价格" min-width="100">
          <template slot-scope="scope">
            <section v-if="scope.row.isAppCurriculum === '1'">{{ scope.row.appCurriculumPrice }}</section>
            <section v-else>/</section>
          </template>
        </el-table-column>
        <el-table-column prop="setmealPrice" label="套餐价格" min-width="100">
          <template slot-scope="scope">
            <section v-if="scope.row.isSetmeal	=== '1'">{{ scope.row.setmealPrice }}</section>
            <section v-else>/</section>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button type="text" class="textPurple" @click="editTextBookClick(scope.row)">编辑</el-button>
            <el-button type="text" class="textOrange" @click="deleteTextBook(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </TableContainer>
    <GPagination
      ref="ref_GPagination"
      :total.sync="searchForm.total"
      :page.sync="searchForm.page"
      :size.sync="searchForm.size"
      :current-page="searchForm.page"
      @pagination="fetchDataBySearch"
    />
    <GDialog
      :dialog.sync="addTextBookDialog"
      :width="'80%'"
      @btnSure="addSubmitForm('ref_textBookForm')"
      @btnClose="resetAddTextBookForm('ref_textBookForm')"
    >
      <add-text-book
        v-if="addTextBookDialog.visible"
        ref="addTextBookRefs"
        :add-text-book-form.sync="addTextBookForm"
      />
    </GDialog>
    <!--
            编辑园所教材事件的对话框
          -->
    <GDialog

      :dialog.sync="editTextBookDialog"
      :width="'80%'"
      @btnSure="editSubmitForm('editTextBookRefs')"
      @btnClose="resetEditTextBookForm('editTextBookRefs')"
    >
      <editTextBook
        v-if="editTextBookDialog.visible"
        ref="editTextBookRefs"
        :edit-text-book-form.sync="editTextBookForm"
      />
    </GDialog>
    <!--
            删除园所教材事件的对话框
          -->
    <GDialog
      :dialog.sync="deleteTextBookDialog"
      @btnSure="submitForm('ref_textBookForm')"
      @btnClose="resetTextBookForm('ref_textBookForm')"
    />
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getGardenTextBook, deleteTextBookByGarden, addTextBookByGarden, editTextBookByGarden } from '../../../api/gardenManagement/api_gardenTextBook'
import { textBookToTabelFunction, currentPage } from '../../../utils/reg'
import addTextBook from './addTextBook.vue'
import editTextBook from './editTextBook.vue'
export default {
  name: '',
  components: {
    addTextBook,
    editTextBook
  },
  data() {
    return {
      searchForm: {
        page: 1,
        size: 20,
        total: 0,
        kindergartenId: '',
        subjectId: '',
        teachingGrade: '',
        teachingType: ''
      },
      editTableData: [],
      addTextBookDialog: {
        title: '标题',
        visible: false
      },
      editTextBookDialog: {
        title: '标题',
        visible: false
      },
      deleteTextBookDialog: {
        title: '标题',
        visible: false
      },
      addTextBookForm: {
        graden: '',
        subject: '',
        textBook: [
        ]
      },
      editTextBookForm: {
        graden: '',
        subject: '',
        textBook: [
        ]
      },
      // 对应的勾选表格数据列表
      tableData: [],
      textBookList: [],
      tableKey: ''
    }
  },
  computed: {
    ...mapState('commonModule', ['selectOptionsLevel', 'selectOptionsSubject', 'orgGardenTree']),
    ...mapState('gardenManagement', ['selectOptionsGraden', 'selectOptionsType', 'textBookCheckedList', 'textBookRules'])
  },
  created() {
    this.GET_SUBJECTTREE()
    this.getOrgTree(3)
    this.fetchDataBySearch()
    this.GET_LEVELSELECTTREE()
    // this.fetchDataBySearch()
  },
  methods: {
    ...mapActions('commonModule', ['GET_SUBJECTTREE', 'getOrgTree', 'GET_LEVELSELECTTREE']),
    // 查询事件
    async fetchDataBySearch() {
      try {
        const res = await getGardenTextBook(this.searchForm)
        console.log(res.records)
        this.textBookList = res.records
        this.searchForm.total = res.total
        // this.tableKey = Math.random()
      } catch (e) {
        this.$message.closeAll()
        this.$message.error(e)
      }
    },
    selectChange() {
      // 防止出现选择时的问题（比如选择第四页后更换搜索条件若搜索出来的数据小于4页则容易出现不显示数据的问题）
      this.searchForm.page = 1
    },
    // 搜索前重置搜索条件
    searchBySync() {
      this.searchForm.page = 1
      this.fetchDataBySearch()
    },
    // 园所添加教材
    addTextBook() {
      this.addTextBookDialog.visible = true
      this.addTextBookDialog.title = '添加教材'
      this.tableData = this.textBookCheckedList
      this.tableData = textBookToTabelFunction(this.textBookCheckedList)
    },
    // 添加教材事件
    testIsTextBookChecked(array) {
      for (const i of array) {
        if (i.checked) {
          return true
        }
      }
      return false
    },
    // 测试是否有任何价格未选中的
    testIsPriceChecked(array) {
      for (const e of array) {
        if (e.teachingPrice.checked || e.bookPrice.checked || e.setmealPrice.checked) {
          return true
        }
      }
    },
    async addSubmitForm() {
      const val = this.$refs.addTextBookRefs.$refs.addTextBookRefs
      try {
        await val.validate()
        if (this.testIsTextBookChecked(this.addTextBookForm.textBook)) {
          const array = []
          for (const i of this.addTextBookForm.textBook) {
            if (i.checked) {
              array.push(i)
            }
          }
          array.length === 0 ? this.$message.error('请选择教材') : this.addListhandle(array, this.addTextBookForm)
        } else {
          this.$message.error('请正确填写内容')
        }
      } catch (error) {
        this.$message.closeAll()
        this.$message.error(error)
      }
    },
    // 关闭园所添加教材对话框回调
    resetAddTextBookForm(target) {
      this.addTextBookDialog = {
        title: '标题',
        visible: false
      }
    },
    // 提交新增操作
    async addListhandle(textBookObj, textFormObj) {
      if (this.testIsPriceChecked(textBookObj)) {
        const array = this.handleFunctionSubmitData(textBookObj, textFormObj)
        try {
          await addTextBookByGarden(array)
          this.$message.success('添加成功')
          this.fetchDataBySearch()
          this.resetAddTextBookForm()
        } catch (e) {
          this.$message.closeAll()
          this.$message.error(e)
        }
      } else {
        this.$message.error('教材选择后请至少填写一项价格')
      }
    },
    // 提交前的代码处理
    handleFunctionSubmitData(textBookObj, textFormObj) {
      const array = []
      textBookObj.forEach(item => {
        const objs = {
          appCurriculumPrice: item.teachingPrice.checked ? item.teachingPrice.price : null,
          bookPrice: item.bookPrice.checked ? item.bookPrice.price : null,
          del: true,
          teachingId: item.teachingId,
          isAppCurriculum: item.teachingPrice.checked ? 1 : 0,
          isBook: item.bookPrice.checked ? 1 : 0,
          isSetmeal: item.setmealPrice.checked ? 1 : 0,
          kindergartenId: textFormObj.kindergartenId,
          setmealPrice: item.setmealPrice.checked ? item.setmealPrice.price : null,
          isTeaching: 1,
          subjectName: textFormObj.subjectName,
          id: item.id ? item.id : null,
          subjectId: textFormObj.subjectId
        }
        array.push(objs)
      })
      return array
    },
    // 园所编辑教材事件

    // 园所删除教材对话框打开事件
    deleteTextBook(e) {
      this.$confirm('此操作将永久删除该教材, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteSync(e)
        })
    },
    async deleteSync(e) {
      try {
        await deleteTextBookByGarden({ kindergartenPriceId: e.id })
        this.$message.success('删除成功')
        this.searchForm.page = currentPage(this.searchForm.page, this.searchForm.size, this.searchForm.total)
        this.fetchDataBySearch()
      } catch (e) {
        this.$message.closeAll()
        this.$message.error(e)
      }
    },
    // 添加页面布局时候的勾选事件
    handleSelectionChange() {},
    // 编辑对话框的打开事件
    editTextBookClick(array) {
      this.editTextBookDialog.visible = true
      this.editTextBookDialog.title = '编辑教材'
      console.log(array)
      this.editTextBookForm = textBookToTabelFunction(array)
    },
    // 编辑园所教材事件的提交事件
    editSubmitForm() {
      const arrayFilter = this.editTextBookForm.textBook.filter(function (item) {
        return item.checked === true
      })
      arrayFilter.length > 0 ? this.editSync(arrayFilter) : this.$message.error('请选择教材')
    },
    async editSync(list) {
      this.$confirm('此操作将更新该教材, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const array = this.handleFunctionSubmitData(list, this.editTextBookForm)
          try {
            await Promise.all(array.map(async item => {
              if (item.id) {
                return await editTextBookByGarden(item)
              } else {
                return await addTextBookByGarden([item])
              }
            }))
            this.$message.success('修改成功')
            this.resetEditTextBookForm()
            this.fetchDataBySearch()
          } catch (e) {
            this.$message.closeAll()
            this.$message.error(e)
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
        })
    },
    // 关闭教材对话框的回调
    resetEditTextBookForm() {
      this.editTableData = []
      this.editTextBookDialog.visible = false
    }

  }
}
</script>

<style>

</style>
